module.exports = __webpack_public_path__ + "ptc_nakagawa_W1.c02b70c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_W1.jpg
// module id = tb4H
// module chunks = 0